// extracted by mini-css-extract-plugin
export var blue = "_r-f";
export var brand = "_r-b";
export var darkGrey = "_r-e";
export var disabled = "_r-4";
export var disabledSubtle = "_r-5";
export var error = "_r-6";
export var green = "_r-g";
export var grey = "_r-d";
export var icon = "_r-0";
export var inherit = "_r-a";
export var lightGrey = "_r-c";
export var orange = "_r-i";
export var pink = "_r-k";
export var primary = "_r-1";
export var purple = "_r-l";
export var red = "_r-j";
export var secondary = "_r-2";
export var success = "_r-9";
export var tertiary = "_r-3";
export var warning = "_r-7";
export var warningSecondary = "_r-8";
export var white = "_r-m";
export var yellow = "_r-h";